import React from "react";
import "./update-institute-details.style.scss";
import CustomDropdown from "../CustomDropdown/CustomDropdown";
import { withStyles } from "@material-ui/core/styles";

import nextId from "react-id-generator";
import { updateInstituteBasicDetails, updateProfileNew, uploadResume } from "../../../APIs/PostAPIS";
import Notification from "../../Portals/Notification/Notification";
import { getAllCities, getAllCountries, getAllStates } from "../../../APIs/GetAPIs";
import { Images } from "../../../Assets/0a-exporter";
import Checkbox from '@material-ui/core/Checkbox';
import CircleChecked from '@material-ui/icons/CheckCircleOutline';
import CircleCheckedFilled from '@material-ui/icons/CheckCircle';
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked';
const CustomColorCheckbox = withStyles({
  overrides: {
    MuiCheckbox: {
      colorSecondary: {
        color: 'green',
        '&$checked': {
          color: 'green',
        },
      },
    },
  },
  checked: {}
})((props) => <Checkbox disabled={true} icon={<CircleUnchecked color="secondary" /> } checkedIcon={<CircleCheckedFilled color="green" sx={{ color: 'green' }}/>} 

{...props} />);
// const theme = createMuiTheme({
//   overrides: {
//     MuiCheckbox: {
//       colorSecondary: {
//         color: '# custom color',
//         '&$checked': {
//           color: '#custom color',
//         },
//       },
//     },
//   },
// });


export default function UpdateInstituteDetails({
  data,
  initialChecking,
  closeIt,
}) {
  const [error, setError] = React.useState(false);
  const [country, setCountry] = React.useState({ name: "", list: [] });
  const [state, setState] = React.useState({ name: "", list: [] });
  const [city, setCity] = React.useState({ name: "", list: [] });
  const [loading, setLoading] = React.useState(false);
  const [tempLogoName, setTempLogoName] = React.useState('');
  const [progressVal, setDynamicProgress] = React.useState(50);

  

  
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });
  const [institutionDetails, setInstitutionDetails] = React.useState({
    institution_id: "",
    institution_website: "",
    institution_name: "",
    no_of_staff: "",
    institute_address: "",
    institute_location: {
      country: "",
      state: "",
      city: "",
      pin: "",
    },
    google_location: "",
    about_institution: "",
    institution_logo: "",
  });
  const clearNotification = () => {
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      closeIt();
      setLoading(false);
      clearTimeout(a);
    }, [1000]);
  };
  const handleUpdate = async () => {
    try {
      setLoading(true);
      let res = await updateProfileNew(data._id, institutionDetails);
      if (res.data.data) {
        initialChecking();
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
        clearNotification();
      } else {
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: ``,
        });
      }

      setLoading(false);
    } catch (error) {
      setNotification({
        status: true,
        title: "SOmething went wrong",
        moreDetails: ``,
      });
    }
  };

  const validations = () => {
    let check =
      !institutionDetails.institution_website ||
      !institutionDetails.no_of_staff ||
      !institutionDetails.institute_address ||
      !institutionDetails.institute_location.country ||
      !institutionDetails.institute_location.state ||
      !institutionDetails.institute_location.city ||
      !institutionDetails.institute_location.pin ||
      !institutionDetails.google_location ||
      !institutionDetails.institution_logo ||
      !institutionDetails.about_institution;
    setError(check);
    return check;
  };
  const setUpCountries = async () => {
    try {
      let res = await getAllCountries();
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.isoCode };
        });
      }
      setCountry({ ...country, list: [...tempList] });
    } catch (error) {}
  };

  const setUpStates = async () => {
    try {
      let res = await getAllStates(country.name);
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.isoCode };
        });
      }
      setState({ name: "", list: [...tempList] });
      setCity({ name: "", list: [] });
      setInstitutionDetails({
        ...institutionDetails,
        institute_location: {
          ...institutionDetails.institute_location,
          country: country.name,
          state: "",
          city: "",
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
  const setUpCities = async () => {
    try {
      let res = await getAllCities(country.name, state.name);
      let tempList;
      if (res.data.data) {
        tempList = res.data.data.map((obj) => {
          return { ...obj, id: obj.name };
        });
      }
      setInstitutionDetails({
        ...institutionDetails,
        institute_location: {
          ...institutionDetails.institute_location,
          state: state.name,
          city: ""
        },
      });
      setCity({ name: "", list: [...tempList] });
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    setUpCountries();
  }, []);
  React.useEffect(() => {
    if (!country.name) return;
    setUpStates();
  }, [country.name]);

  React.useEffect(() => {
    if (!state.name) return;
    setUpCities();
  }, [state.name]);
  React.useEffect(() => {
    setInstitutionDetails({ ...data });
  }, []);
  
  React.useEffect(() => {
    setTimeout(() => {
      if(progressVal<100){ 
        institutionDetails.institution_logo&&setDynamicProgress(progressVal+25)
      }
    }, 1000)
  }, [institutionDetails.institution_logo]);

  const handleImage = async (event) => {
    // setUploading(true);
    let link;
    let doc = event.target.files[0];
    setTempLogoName(doc?.name)

    let ext = doc?.name?.toString()?.split(".");
    if (ext?.length > 1) {
      let extension = ext[ext?.length - 1];
      if (extension === "jpeg" || extension === "jpg" || extension === "png") {
      } else {
        // setUploading(false);
        setNotification({
          status: true,
          title: "Please Select only JPEG or PNG file",
        });
        return;
      }
    } else {
      // setUploading(false);
      setNotification({
        status: true,
        title: "Please Select only JPEG or PNG file",
      });
      return;
    }

    if (doc.size >10000000) {
      // setUploading(false);
      setNotification({
        status: true,
        title: "File must be less than 10MB",
      });
      return;
    }

    const formData = new FormData();
    formData.append("newFile", doc);
    try {
      let res = await uploadResume(formData);
      console.log('res uploadResume huay ',res?.data?.data)
      if (res.data.data) {
        link = res.data.data.file_link;
        // handleUpdate
        setInstitutionDetails({
          ...institutionDetails,
          institution_logo: link
        });
      } else {
        // setUploading(false);
      }
    } catch (error) {
      // setUploading(false);
    }
  };

const removeImage=()=>{
  setInstitutionDetails({
    ...institutionDetails,
    institution_logo: ''
  });
  setTempLogoName('')
  setDynamicProgress(50)
}

  return (
    <div onClick={() => closeIt()} className="update-institute-details">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <div onClick={(e) => e.stopPropagation()} className="uid-modal">
        <header className="uid-m-header">
          <h5>Update Institute</h5>
        </header>
        <section className="uid-m-body">
          {" "}
          <div
            className={`fancy-input-wrapper ${
              error && !institutionDetails.institution_website ? "error" : ""
            }`}
          >
            <span>Official website*</span>
            <input
              name="institution_website"
              onChange={(e) =>
                setInstitutionDetails({
                  ...institutionDetails,
                  institution_website: e.target.value,
                })
              }
              value={institutionDetails.institution_website}
              placeholder=""
              required
            />
          </div>
          <div
            className={`fancy-input-wrapper ${
              error && !institutionDetails.institute_address ? "error" : ""
            }`}
          >
            <span>Institute Address*</span>
            <input
              name="institution_website"
              onChange={(e) =>
                setInstitutionDetails({
                  ...institutionDetails,
                  institute_address: e.target.value,
                })
              }
              value={institutionDetails.institute_address}
              placeholder=""
              required
            />
          </div>
          <CustomDropdown
            list={staffList}
            message="Select No of staff"
            title="No. of Staff*"
            selected={institutionDetails.no_of_staff}
            error={error && !institutionDetails.no_of_staff}
            sendClicked={(obj) =>
              setInstitutionDetails({
                ...institutionDetails,
                no_of_staff: obj.id,
              })
            }
          />
          <CustomDropdown
            list={country.list}
            message="Select country"
            title="Country*"
            error={error && !institutionDetails.institute_location.country}
            selected={institutionDetails.institute_location.country}
            sendClicked={(obj) => {
              setInstitutionDetails({
                ...institutionDetails,
                institute_location: {
                  ...institutionDetails.institute_location,
                  country: obj.id,
                },
              });
              setCountry({ ...country, name: obj.id });
            }}
          />
          <CustomDropdown
            error={error && !institutionDetails.institute_location.state}
            sendClicked={(obj) => {
              setInstitutionDetails({
                ...institutionDetails,
                institute_location: {
                  ...institutionDetails.institute_location,
                  state: obj.id,
                },
              });
              setState({ ...state, name: obj.id });
            }}
            list={state.list}
            message="Select state"
            title="State*"
            selected={institutionDetails.institute_location.state}
          />
          <CustomDropdown
            error={error && !institutionDetails.institute_location.city}
            sendClicked={(obj) => {
              setInstitutionDetails({
                ...institutionDetails,
                institute_location: {
                  ...institutionDetails.institute_location,
                  city: obj.id,
                },
              });
              setCity({ ...city, name: obj.id });
            }}
            list={city.list}
            message="Select city"
            title="City*"
            selected={institutionDetails.institute_location.city}
          />
          <div
            className={`fancy-input-wrapper ${
              error && !institutionDetails.institute_location.pin ? "error" : ""
            }`}
          >
            <span>Pin Code*</span>
            <input
              type="number"
              value={institutionDetails.institute_location.pin}
              onChange={(e) =>
                setInstitutionDetails({
                  ...institutionDetails,
                  institute_location: {
                    ...institutionDetails.institute_location,
                    pin: e.target.value,
                  },
                })
              }
              placeholder="Enter pin"
              required
            />
          </div>
          <div
            className={`fancy-input-wrapper ${
              error && !institutionDetails.google_location ? "error" : ""
            }`}
          >
            <span>Google Map Location*</span>
            <input
              onChange={(e) =>
                setInstitutionDetails({
                  ...institutionDetails,
                  google_location: e.target.value,
                })
              }
              value={institutionDetails.google_location}
              placeholder="location"
              required
            />
          </div>
          <div
            className={`fancy-input-wrapper ${
              error && !institutionDetails.about_institution ? "error" : ""
            }`}
          >
            <span>About Institute*</span>
            <textarea
              rows="6"
              style={{ height: "auto" }}
              cols={10}
              onChange={(e) =>
                setInstitutionDetails({
                  ...institutionDetails,
                  about_institution: e.target.value,
                })
              }
              value={institutionDetails.about_institution}
              placeholder=""
              required
            />
          </div>
          <h5 className="upload-logo-header">Upload Institute Logo</h5>
          <span className="upload-logo-condition">Logo (Only PNG, JPG formats. Max size upto 100 MB)</span>
          <div className="resume-upload-area">  
            <label htmlFor="resume" className="upload-area">
              <input
              accept="image/png, image/gif, image/jpeg, image/jpg"
                onChange={(e) => {
                  handleImage(e);
                  e.target.value = "";
                }}
                id="resume"
                className="d-none"
                type="file"
              />
             {institutionDetails.institution_logo?<img src={institutionDetails.institution_logo} />:<img src={Images.uploadLogo} />} 
                <div className="completion upload-image-logoo">
              <div className="completion-above">
                <span>

                <h6>{tempLogoName?tempLogoName:''}</h6>
                {tempLogoName&& <button onClick={() => removeImage()}>
        <img src="https://img.icons8.com/fluency-systems-filled/48/000000/cancel.png"/>
        </button>}

                </span>

                {tempLogoName&&institutionDetails.institution_logo&&<h6>{progressVal}%</h6>}
              </div>
              {tempLogoName&&institutionDetails.institution_logo&&<progress value={progressVal} max="100" />}
              </div>
{tempLogoName&&institutionDetails.institution_logo&&progressVal===100&&<CustomColorCheckbox checked={true} />}
            </label>
          </div>
          <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
        </section>
        <footer className="uid-footer">
          <button
            onClick={() => (validations() ? console.log('validation not done') : handleUpdate())}
          >
            {loading ? "Updating...." : "Update"}
          </button>
        </footer>
      </div>
    </div>
  );
}

const staffList = [
  { _id: nextId(), name: "1 - 50", id: "1_50" },
  { _id: nextId(), name: "50 - 100", id: "50_100" },
  { _id: nextId(), name: "100 - 200", id: "100_200" },
  { _id: nextId(), name: "200 +", id: "200+" },
];
